export const SET_COLUMNS = 'SET_COLUMNS';
export function setColumns(columns) {
  return { columns, type: SET_COLUMNS };
}
